import { staticRoutes, dynamicRoutes } from "@/router/appRoutes";

function $_routeAlreadyExist(route, existingRoutes) {
  if (existingRoutes && existingRoutes.length) {
    return existingRoutes.findIndex(er => er.name === route.name) > -1;
  }
  return false;
}

function $_hasPermission(route, entity, roles) {
  if (route.meta && route.meta.roles && route.meta.entities) {
    let roleMatched = roles.some(role => route.meta.roles.indexOf(role) > -1);
    let entityMatched = route.meta.entities.indexOf(entity) > -1;
    return roleMatched && entityMatched;
  } else {
    // 没有 meta.roles 和 meta.entities 说明没有 permission 限制
    return true;
  }
}

function $_getAccessableRoutes(routes, entity, roles, existingRoutes) {
  let accRoutes = [];
  for (let route of routes) {
    if (
      !$_routeAlreadyExist(route, existingRoutes) &&
      $_hasPermission(route, entity, roles)
    ) {
      // 注意不能改到 routes 本身
      let newRoute = { ...route };
      if (route.children && route.children.length) {
        newRoute.children = $_getAccessableRoutes(
          route.children,
          entity,
          roles,
          existingRoutes
        );
      }
      accRoutes.push(newRoute);
    }
  }
  return accRoutes;
}

export default {
  namespaced: true,
  state: {
    userRoutes: [],
    dynamicUserRoutes: []
  },

  getters: {
    userRoutes(state) {
      if (!state.userRoutes || !state.userRoutes.length) {
        return staticRoutes;
      }
      return state.userRoutes;
    },
    dynamicUserRoutes(state) {
      if (!state.dynamicUserRoutes || !state.dynamicUserRoutes.length) {
        return [];
      }
      return state.dynamicUserRoutes;
    }
  },

  actions: {
    generateUserRoutes({ commit }, { existingRoutes, entity, roles }) {
      return new Promise(resolve => {
        // 所有的有权限的 route
        let accessableRoutes = $_getAccessableRoutes(
          dynamicRoutes,
          entity,
          roles
        );
        // 去除已存在的 route，为了防止 addRouter 的重复添加
        let nonExistAccessableRoutes = $_getAccessableRoutes(
          dynamicRoutes,
          entity,
          roles,
          existingRoutes
        );
        commit("SET_USER_ROUTES", staticRoutes.concat(accessableRoutes));
        commit("SET_DYNAMIC_USER_ROUTES", nonExistAccessableRoutes);
        resolve();
      });
    },
    clearUserRoutes({ commit }) {
      commit("SET_USER_ROUTES", staticRoutes);
      commit("SET_DYNAMIC_USER_ROUTES", []);
    }
  },

  mutations: {
    SET_USER_ROUTES(state, userRoutes) {
      state.userRoutes = userRoutes;
    },
    SET_DYNAMIC_USER_ROUTES(state, dynamicUserRoutes) {
      state.dynamicUserRoutes = dynamicUserRoutes;
    }
  }
};
